/*
 * Focus Trap helpers
 */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  first.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args)
      t = true;
      setTimeout(() => t = false, wait)
    }
  }
}

/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.DetailsAccordions.init();

   // Attach theme editor listeners
   if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:block:select', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]')
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
        // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:unload', (evt) => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId)
  })

  document.addEventListener('shopify:section:select', (evt) => {
    console.log('shopify:section:select', evt.detail.sectionId)
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:deselect', (evt) => {
    console.log('shopify:section:deselect', evt.detail.sectionId)
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');

      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');

        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format) {
    const default_money_format = theme.settings.moneyFormat || '€{{amount}}';
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if (window?.Shopify?.currency?.rate) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }
    
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    cartBlip: '.cart-blip'
  },
  cache: {
    header: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined
  },

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]')

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this))
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior)
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType
    }

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight}px`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      const toggleStickyHeader = (direction, curScroll) => {
        if ((direction === 1) || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide')
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide')
        }

        prevDirection = direction;
      }

      window.addEventListener('scroll', throttle(() => {
        curScroll = window.scrollY || document.documentElement.scrollTop;

        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show')
        } else {
          document.documentElement.classList.remove('sticky-header-show');
        }

        if (curScroll > prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }

        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll)
        }

        prevScroll = curScroll
      }, 50))

      setInterval(() => {
        if (direction === 2 && behaviorType === 'scroll' && curScroll >= 900) {
          toggleStickyHeader(direction, curScroll);
        }
        if (window.scrollY === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
        }
      }, 200)
    }
  },

  async updateCartBlip(e) {
    const cart = e.detail && e.detail.cart && e.detail.cart.item_count || await (async function () {
      const res = await fetch('/cart.json');
      const cart = await res.json();
      return cart;
    })();

    this.cache.cartBlip.textContent = cart.item_count || 0;
    if (cart && cart.item_count == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
      this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
    } else {
      this.cache.cartBlip.removeAttribute('hidden')
      this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
    }

    // Update notification cart amount at the same time (if present)
    const total_in_notification = document.querySelector('#cart-notification-link .cart-total');
    if (total_in_notification) {
      total_in_notification.textContent = cart.item_count;
    }
  }
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="modal"]:not(.quick-buy_link)',
      drawerLink: 'a[href*="drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
        this.showModalOrDrawer(targetId, parseInt(pageId));
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
        this.showModalOrDrawer(targetId, parseInt(pageId));
      });
    });

    // Init close event listeners
    const closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    const overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    // Escape to close all
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        document.querySelectorAll('.drawer').forEach((drawer) => {
          drawer.classList.remove('is-open');
        });
        document.querySelectorAll('.modal').forEach((modal) => {
          modal.classList.remove('is-open');
        });
        document.body.classList.remove('overflow-hidden');
      }
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} pageId - ID of page to load in modal or drawer, e.g. 1, 2, 3 (for multi-modal)
   * Traps focus to modal and disables body scrolling.
   * Focus trap utilizes focus-trap library: https://github.com/focus-trap/focus-trap
   */
  showModalOrDrawer: function (targetId, pageId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    if (targetElement.classList.contains('is-open')) return;

    targetElement.classList.add('initialized', 'is-open');
    document.body.classList.add('overflow-hidden');
    const isMultiModal = targetElement.nodeName === 'MODAL-GRIDY-SLIDER-PARENT';

    setTimeout(() => {
      trapFocus(targetElement);
    }, 600);

    setTimeout(() => {
      // check targetElement node name to determine if it's a modal or drawer
      if (pageId && isMultiModal) {
        const gridySlider = targetElement.querySelector('gridy-slider');
        gridySlider.scrollToSlide(pageId - 1);
      }
    }, 600);
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    removeTrapFocus();
    const parentElement = event.currentTarget.closest('[data-parent]');
    const targetId = parentElement.getAttribute('id');
    parentElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }
};

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  250
);

/**
 * Animated details element
 */
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
    this.toggleByViewport();
    document.addEventListener('woolman:resize', this.toggleByViewport.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    
    if (this.animation) {
      this.animation.cancel();
    }
    
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-in-out'
    });
    
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    
    if (this.animation) {
      this.animation.cancel();
    }
    
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  toggleByViewport() {
    let mobileClose = this.el.dataset.mobileClose != undefined ? JSON.parse(this.el.dataset.mobileClose) : false;
    let desktopOpen = this.el.dataset.desktopOpen != undefined ? JSON.parse(this.el.dataset.desktopOpen) : false;
    
    if (woolman_window_size >= 768 && desktopOpen) {
      this.el.open = true;
    } else if (mobileClose) {
      this.el.open = false;
    }
  }
};

Woolman.DetailsAccordions = {
  init: function () {
    document.querySelectorAll('details').forEach((el) => {
      new Accordion(el);
    });
  }
};

Woolman.init();

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]')
    };

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();
    
    this.video = this.querySelector('video') || this.querySelector('iframe');
    this.container = this.closest('.video-container') || null;

    if (this.container) this.attachClickListener(this.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (this.video.nodeName === 'IFRAME' && this.video.src && this.video.src.includes('youtube') && !this.container) {
      this.video.addEventListener('load', this.onVideoLoad.bind(this));
    }

    // When video is out of viewport pause it. This is to prevent videos from playing in the background.
    // If video is in viewport play it.
    // Use: Intersection Observer API
    const autoplay = this.dataset.autoplay || false;
    if (!autoplay || this.container) return;

    const videoType = this.video.nodeName === 'VIDEO' ? 'video' : 'iframe';
    const videoHost = this.video.nodeName === 'VIDEO' ? 'shopify' : (this.video.src.includes('youtube') ? 'youtube' : 'vimeo');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (videoType == 'video') {
            this.video.play();
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"play"}', '*');
          }
        } else {
          if (videoType == 'video') {
            this.video.pause()
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    } , { threshold: 0.5 });

    observer.observe(this.video);
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', (e) => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    this.video.onplay = () => {
      videoContainer.querySelector('button').hidden = true;
    }

    this.video.onpause = () => {
      videoContainer.querySelector('button').hidden = false;
    }
  }

  onVideoLoad() {
    // force youtube to play on mobile
    this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
}
customElements.define('superpowered-video', SuperPoweredVideo);

// Gridy Slider - a custom Woolman built slider.
// Usage: <gridy-slider>
class GridySlider extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('.gridy-track');
    this.slides = this.querySelectorAll('.gridy-track > *');
    const child_count = this.track.childElementCount;

    const data_ipr_desktop = parseInt(this.dataset.iprDesktop, 10) || 1;
    const data_ipr_tablet = parseInt(this.dataset.iprTablet, 10) || data_ipr_desktop;
    const data_ipr_mobile = parseInt(this.dataset.iprMobile, 10) || 1;
    const data_init_scroll_to = this.dataset.initScrollTo;
    const data_autoplay = this.dataset.autoplay != undefined ? JSON.parse(this.dataset.autoplay) : false;
    const data_autoplay_delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
    const data_is_thumbnails_slider = this.dataset.thumbnailsFor != undefined ? true : false;
    const data_indicator = this.dataset.indicator != undefined ? JSON.parse(this.dataset.indicator) : false;
    const data_thumbnail_slider = document.getElementById(`thumbnail-${this.id}`);
    const data_track_overflow_visible = this.dataset.overflowVisible != undefined ? true : false;

    this.config = {
      slide_count: child_count,
      current_slide: 0,
      active_slide_offset: 0, // used for thubnails slider

      ipr_desktop: data_ipr_desktop,
      ipr_tablet: data_ipr_tablet,
      ipr_mobile: data_ipr_mobile,
      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,

      arrows: true,
      autoplay: data_autoplay || false, 
      autoplay_delay: data_autoplay_delay, // in ms
      timer: null,

      // thumbnails related
      is_thumbnails_slider: data_is_thumbnails_slider,
      thumbnails_for: undefined,
      thumbnail_slider: data_thumbnail_slider,

      indicator: data_indicator,

      track_overflow_visible: data_track_overflow_visible
    }

    // SCROLL ON INIT (with variant URL)
    if (data_init_scroll_to != undefined) {
      this.scrollToSlideByID(data_init_scroll_to);
    }

    // ARROWS INIT
    if (this.config.arrows) {
      this.buttons = this.querySelectorAll('[data-gridy-arrow]');
      this.buttons.forEach((arrowButton) => {
        arrowButton.addEventListener('click', this.onArrowClick.bind(this));
      });
    }

    // AUTOPLAY INIT
    if (this.config.autoplay) {
      this.autoplayGridy();

      // Always pause on hover
      this.addEventListener('mouseenter', this.clearAutoplayTimer);
      this.addEventListener('mouseleave', this.autoplayGridy);

      // Pause for touch devices
      this.addEventListener('touchenter', this.clearAutoplayTimer);
      this.addEventListener('touchleave', this.autoplayGridy);
    }

    // THUMBNAILS INIT
    if (this.config.is_thumbnails_slider) {
      this.config.active_slide_offset =  2,
      this.config.thumbnails_for = document.getElementById(this.dataset.thumbnailsFor);
      this.thumbnail = this.querySelectorAll('[data-thumbnail-btn]');
      this.thumbnail.forEach((thumbnail) => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
      });
    }

    // CURRENT SLIDE INDICATORS INIT
    if (this.config.indicator) {
      this.indicator_dots = this.querySelectorAll('[data-indicator-dot]');
      this.indicator_current = this.querySelector('[data-indicator-current]');
    }

    // SCROLL LISTENER (for setting active slide after normal scroll)
    if (!this.config.is_thumbnails_slider) {
      let scrollTimeout;
      this.track.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.afterScrollStops.bind(this), 200);
      }.bind(this));
    }
  }

  afterScrollStops() {
    let slideInView = this.firstSlideInView();
    this.config.current_slide = slideInView;
    this.setActiveSlide(this.slides[slideInView + this.config.active_slide_offset]);

    // SYNC BACK TO THUMBNAILS SLIDER
    if (this.config.thumbnail_slider) {
      this.config.thumbnail_slider.scrollToSlide(slideInView);
    }
  }

  autoplayGridy() {
    this.config.timer = setInterval(this.scrollByIPR.bind(this), this.config.autoplay_delay, 'next');
  }

  clearAutoplayTimer() {
    clearInterval(this.config.timer);
    this.config.timer = null;
  }

  onThumbnailClick(event) {
    event.preventDefault();
    this.config.current_slide = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
    this.config.thumbnails_for.scrollToSlideByID(event.currentTarget.dataset.itemId);
    this.scrollToSlide(this.config.current_slide);
  }

  onArrowClick(event) {
    this.scrollByIPR(event.currentTarget.dataset.direction);
  }

  scrollByIPR(direction) {
    let slideMultiplier = this.getCurrentSlideMultiplier(),
        newCurrentSlide = this.config.current_slide;

    if (direction === 'next') {
      newCurrentSlide = (newCurrentSlide + slideMultiplier);
    } else if (direction === 'prev') {
      newCurrentSlide = (newCurrentSlide - slideMultiplier);
    }

    if ((newCurrentSlide + 1 ) > this.config.slide_count || this.config.current_slide > 0 && newCurrentSlide < 0) {
      newCurrentSlide = 0;
    } else if (newCurrentSlide < 0) {
      newCurrentSlide = this.config.slide_count - slideMultiplier;
    }

    this.config.current_slide = newCurrentSlide;

    this.scrollToSlide(newCurrentSlide);
  }

  scrollToSlide(newPosition) {
    // Needs to use scrollTo() instead of scrollIntoView()
    // since the later affects window scroll and thus cannot
    // be used with autoplay sliders.

    if (isNaN(newPosition)) {
      return;
    }

    // Can show different active slide compared to scrollTo slide for example in thumbnails slider
    let slidePosWithOffset = newPosition - this.config.active_slide_offset,
        newScrollToSlidePos = slidePosWithOffset > 0 ? slidePosWithOffset : 0;

    const slideInNewScrollToPos = this.slides[newScrollToSlidePos];
    
    let scrollToLeft = slideInNewScrollToPos.offsetLeft,
        scrollToTop = slideInNewScrollToPos.offsetTop;

    // If the track overflow is visible the scroll offset much include the left padding of the track
    // That is calculated with the first child offsetLeft
    if (this.config.track_overflow_visible) {
      scrollToLeft = this.slides[newScrollToSlidePos].offsetLeft - this.slides[0].offsetLeft;
    }
    
    this.track.scrollTo({
      left: scrollToLeft,
      top: scrollToTop,
      behavior: "smooth",
    });

    this.slides.forEach((item) => { item.classList.remove('active') });
    this.slides[newPosition].classList.add('active');
  }

  scrollToSlideByID(slideID) {
    // Second scrollTo method used with slideID
    // Used through thumbnails and variant change events

    const theSlide = document.getElementById(slideID),
          newPosition = Array.from(theSlide.parentNode.children).indexOf(theSlide);
    
    this.scrollToSlide(newPosition);
  }

  setActiveSlide(slide) {
    this.slides.forEach((item) => { item.classList.remove('active') });
    slide.classList.add('active');
    
    if (this.config.indicator) {
      this.indicator_current.textContent = this.config.current_slide + 1;
      this.indicator_dots.forEach((dot) => { dot.classList.remove('active') });
      this.indicator_dots[this.config.current_slide].classList.add('active');
    }
  }

  getCurrentSlideMultiplier() {
    let currentSlideMultiplier = this.config.ipr_mobile;
    if (woolman_window_size >= this.config.breakpoint_desktop) {
      currentSlideMultiplier = this.config.ipr_desktop;
    } else if (woolman_window_size >= this.config.breakpoint_tablet) {
      currentSlideMultiplier = this.config.ipr_tablet;
    }
    return currentSlideMultiplier; 
  }

  // Utility, returns the position of the first slide in view (1..n)
  firstSlideInView() {
    let loopIndex = 0;
    for (const slide of this.slides) {
      if (this.isSlideInView(slide)) {
        return loopIndex;
      }
      ++loopIndex;
    }

    // If visibility check fails return the last known current_slide
    return this.config.current_slide;
  }

  // Element visibility check
  isSlideInView(slide) {
    const containerBounds = this.track.getBoundingClientRect();
    const slideBounds = slide.getBoundingClientRect();

    const isSlideVisible =
    Math.round(slideBounds.top) >= Math.floor(containerBounds.top) &&
    Math.floor(slideBounds.bottom) <= Math.round(containerBounds.bottom) &&
    Math.round(slideBounds.left) >= Math.floor(containerBounds.left) &&
    Math.floor(slideBounds.right) <= Math.round(containerBounds.right);

    return isSlideVisible;
  }

}
customElements.define('gridy-slider', GridySlider);

// QuantityInput for + and - button functionality
// Used in: cart items, upsell items
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

//Make a function that runs on page load that checks for a select element with an id of tags-select
//Make a variable that is an array of all possible options
//Map over array and create a list of options that have the value set to the array value and a display value that replaces dashes with spaces
//Take the output of the map and insert these options into the select input replacing the current set of options in the html
//replace the main product image source with the constructed value from the selected option and the prefix path.
//For example te base url will be "https://cdn.shopify.com/s/files/1/0642/8599/9281/files/"
//append the option value next for example "USS-Montana-Committee-2023-1"
//Next append ".jpg"
//The final url would be like "https://cdn.shopify.com/s/files/1/0642/8599/9281/files/USS-Montana-Committee-2023-1.jpg"
//Map over the initial array again and construct a list of images with constructed value
//Insert image list into div with id tags-images
document.addEventListener('DOMContentLoaded', function () {


            const currentPageUrl = window.location.href;
            if (currentPageUrl.includes("custom")) {
              
            
                      const selectElement = document.getElementById('tags-select');
                      const imageListElement = document.getElementById('tags-images');
                      const mainProductImageElement = document.querySelector('.product-media figure img');
          
                      const optionsArrayDefault = [
                        "Default-Vehicle-Custom-Tag"
                      ];
                      const optionsArrayMotorcycle = [
                        "Default-Custom-Tag",
                        "ChromeforKids2023_Motorcycle"
                      ];
                      const optionsArrayVehicle = [
                          "Better-the-Farm-2023",
                          "Montana-Wilderness-Association-2023",
                          "Project-WET-Foundation-2023",
                          "Ramsey-Keller-Memorial-2023",
                          "Richland-Youth-Hockey-2023",
                          "The-Way-Home-2023",
                          "Tough-Enough-to-Wear-Pink-MT-2023",
                          "Two-percent-for-Conservation-2023",
                          "United-in-Light-2024",
                          "United-Property-Owners-of-MT-2023-scaled-1200x600",
                          "University-of-MT-Clock-Tower-2023",
                          "University-of-MT-Griz-2023",
                          "University-of-MT-Western-Foundation-2023",
                          "Veterans-Monument-Inc-2023",
                          "Veterans-Navigation-Network-2024",
                          "Violence-Free-Crisis-Line-2023",
                          "Walleyes-Unlimited-of-MT-2023",
                          "Western-Sustainability-Exchange-2023",
                          "YAAK-Valley-Forest-2023",
                          "Yellowstone-Forever-2023",
                          "Yellowstone-Wildlife-Sanctuary-2023",
                          "Youth-Overcoming-Lifes-Obstacles-2023",
                          "YWCA-Missoula-2024",
                          "Zoo-Montana-2023-1",
                          "Museum-of-the-Rockies-2023",
                          "National-Ski-Patrol-MT-Snowbowl-2023",
                          "National-Wildlife-Federation-2023",
                          "Native-Ecosystmes-Council-2023",
                          "Neighbor-to-Neighbor-2023",
                          "Northeast-MT-Fair-Rodeo-Committee-2023",
                          "Northern-Cheyenne-Tribe-2023",
                          "One-Heart-Warriors-2023",
                          "Public-Land-Water-Access-Association-2023",
                          "Recycle-MT-Inc-2023",
                          "Rocky-Mountain-College-2023",
                          "Rocky-Mountain-Elk-Foundation-2023",
                          "Rocky-Mountain-Medical-Foundation-2023",
                          "Salish-Kootenai-College-2023",
                          "Search-Assist-2023",
                          "Somers-Volunteer-Firefighters-Association-2023",
                          "South-Kalsipell-Volunteer-Firefighters-Association-2023",
                          "Stafford-Animal-Shelter-2023",
                          "Sustainable-Montana-2023",
                          "Sweet-Grass-Community-Foundation-2023",
                          "The-Frontier-Institute-2023",
                          "The-Heart-of-the-Valley-2023",
                          "The-Montana-Land-Reliance-2023",
                          "The-Vital-Ground-Foundation-2023",
                          "Montana-Raptor-Conservation-Center-2023",
                          "Montana-Snowmobile-Association-2023",
                          "Montana-Spay-Neuter-Task-Force-2023",
                          "Montana-State-Council-of-Professional-Firefighters-2023",
                          "Montana-State-Fire-Chiefs-Association-2023",
                          "Montana-State-Golf-Association-2023",
                          "Montana-Stockgrowers-Association-2023",
                          "Montana-Support-Our-Troops-2023",
                          "Montana-Tech-2023",
                          "Montana-Timber-Legacy-2023",
                          "Montana-Veterans-Alliance-2023",
                          "Montana-Weed-Control-Association-2023",
                          "Montana-Wild-Sheep-Foundation-2024",
                          "MSU-Go-Cats-2023",
                          "MSU-Great-Falls-College",
                          "MSU-Mountains-Minds-2023",
                          "MSU-Northern-2023",
                          "Mule-Deer-Foundation-2023",
                          "Our-Montana-Inc-2023",
                          "Outlaw-Baseball-Club-2023",
                          "Patriot-MT-Veteran-Affairs-2023",
                          "Pheasants-Forever-Inc-2023",
                          "Postpartum-Resource-Group-2023",
                          "Prickly-Pear-Land-Trust-2023",
                          "Montana-Concerns-of-Police-Survivors-2023",
                          "Montana-Council-of-Trout-Unlimited-2023",
                          "Montana-Cowboy-Hall-of-Fame-2023",
                          "Montana-Cutting-Horse-2023-1",
                          "Montana-Environmental-Info-Center-2023",
                          "Montana-Family-Institute-2023",
                          "Montana-Farm-Bureau-Foundation-2023",
                          "Montana-Food-Bank-Network-2023",
                          "Montana-Grains-Foundation-2023",
                          "Montana-Home-Private-Schools-2023",
                          "Montana-Hope-Project-2023-1-1200x600",
                          "Montana-Horse-Sanctuary-2023",
                          "Montana-Loon-Society-2023",
                          "Montana-Natural-History-2024",
                          "Montana-Pilots-Association-2023",
                          "Montana-Police-Protective-Association-2023",
                          "Montana-Public-Policy-Center-2023",
                          "Montana-Public-Radio-UM-Foundation-2023",
                          "Montana-Safety-Service-Council-Inc-2023",
                          "Montana-State-Parks-Foundation-Inc-2023",
                          "Montana-Wildlife-Federation-2023",
                          "Montana-Youth-Sports-Association-2023",
                          "MSU-Billings-2023",
                          "MSU-Bobcat-Club-2023",
                          "Flathead-Valley-Community-College-2023",
                          "Fort-Belknap-Indian-Community-2023",
                          "International-Choral-Festival-2023",
                          "Jeannette-Rankin-Peace-Center-2023",
                          "Laurel-Public-Library-Foundation-2024",
                          "Lewis-Clark-Bicentennial-2023",
                          "Lewis-Clark-Humane-Society-2023",
                          "Livestock-Loss-Board-2023",
                          "Loving-HOME-Foundation-2023",
                          "Manhattan-Town-Council-2023",
                          "Miles-Community-College-2023",
                          "Milestown-Communty-Improvement-Inc-2023",
                          "Missoula-Butterfly-House-Insectarium-2023",
                          "Missoula-Downtown-Foundation-2023",
                          "Missoula-Freestyle-Team-2023",
                          "Missoula-Horse-Council-Big-Sky-Horse-Park-2023",
                          "Montana-4-H-Foundation-2023",
                          "Montana-Agricultural-Heritage-Foundation-2023",
                          "Montana-Association-of-Symphony-Orchestras-2023",
                          "Montana-Audubon-2023",
                          "Montana-Beyond-The-Classroom-2023",
                          "Montana-Bowhunter-Education-2023",
                          "Montana-FFA-Foundation-Inc-2023",
                          "Montana-Mobile-Museum-2024",
                          "Cody-Dieruf-Benefit-Foundation-2023",
                          "Community-Food-Ag-Coalition-2023",
                          "Community-Foundation-for-a-Better-Big-Fork-2023",
                          "Compassion-MT-2023",
                          "Council-on-Wildlife-Fish-2023",
                          "Creating-Community-MT-2023",
                          "Fort-Belknap-College-2023",
                          "Fossil-Rims-2023",
                          "Friends-of-Lee-Metcalf-National-Wildlife-Refuge-2023",
                          "Friends-of-Montana-PBS-2023",
                          "Friends-of-NRA-2023",
                          "Gallatin-Ice-Foundation-Inc-2023",
                          "Gallatin-Open-Lands-2023",
                          "Gallatin-River-Task-Force-2023",
                          "Gallatin-Valley-Land-Trust-2023",
                          "Garnet-Preservation-Association-Inc-2023",
                          "Glacier-Institute-2023",
                          "Glacier-National-Park-GNP-Conservancy-2023",
                          "Glasgow-Scotty-Booster-Club-2023",
                          "Greater-Yellowstone-Coaltion-2023",
                          "Grizzly-Scholarship-Association-2023",
                          "Grizzly-Wolf-Discovery-Center-2023",
                          "Helena-College-2023",
                          "Humane-of-Society-NW-MT-2023",
                          "Bird-of-Pray-Foundation-2023",
                          "Bitterroot-Humane-Association-2023",
                          "Blackfeet-Tribe-2023",
                          "Bob-Marshall-Foundation-2023",
                          "Boone-Crocket-Club-2023",
                          "Bridger-Ski-Foundation-2023",
                          "Buffalo-Field-Campaign-2023",
                          "Butte-Silver-Bow-Gov-2023",
                          "Cancer-Support-Community-of-MT-2023",
                          "Catalyst-for-Change-2023",
                          "Custer-Battlefield-Museum-2023",
                          "Dawson-Community-College-2023",
                          "DEAP-Developmental-Educational-Assistance-Program-2023",
                          "Dress-for-Success-2023",
                          "Ducks-Unlimited-Inc-2023",
                          "Eagle-Mount-Bozeman-2023",
                          "Eastgate-VFD-Association-2023",
                          "Ecology-Project-International-2023",
                          "Elizabth-Custer-Library-Museum-2023",
                          "Eureka-MT-Quilt-Show-2023",
                          "Experimental-Aircraft-Association-517-Inc-2023",
                          "Five-Valleys-Land-Trust-2023",
                          "Flathead-County-Sheriffs-Posse-2023",
                          "Flathead-Lake-Protection-Association-2023",
                          "1776-Foundation-2023",
                          "406-Pickle-Ball-Missoula-Inc-2023",
                          "Absaroka-Beartooth-Wilderness-Foundation-2023",
                          "Alliance-for-the-Wild-Rockies-2023",
                          "Alternative-Energy-Resources-2023",
                          "American-Red-Cross-Five-Rivers-District-2023",
                          "Backcountry-Hunters-Anglers-2023",
                          "Baker-Baseball-Association-2023",
                          "Bear-Creek-Council-2023",
                          "Beartooth-Back-Country-Horsemen-2023",
                          "Benefis-Mercy-Flight-2023",
                          "Big-Sky-Bravery-2023",
                          "Big-Sky-Ski-Education-Fund-2023-1200x600",
                          "Bighorn-River-Alliance-2023",
                          "Billings-Christian-School-Education-Foundation-2023",
                          "Blackfoot-Challenge-Inc-2023",
                          "Carroll-College-2023",
                          "Chase-Hawks-Memorial-Association-2023",
                          "Chicks-n-Chaps-Inc-2023",
                          "Citizens-Balanced-Use-2023",
                          "City-of-Billings-City-Council-2023",
                          "City-of-Laurel-2024",
                          "City-of-Missoula-Parks-Rec-Dept-2023",
                          "Clark-Fork-Coalition-2023",
                          "A-Heart-For-Horses-2023",
                          "American-Rivers-Inc-2023",
                          "Animal-Foundation-of-Great-Falls-2024",
                          "Biomimicry-Institute-2023-1200x600",
                          "plate-reissued1991-300x152-1",
                          "plate-reissued2000-300x152-1",
                          "plate-reissued2006-300x152-1",
                          "StandardAlternative1889Centennial",
                          "USS-Montana-Committee-2023-1"
                      ];
          
                      const isMotorcycle = currentPageUrl.includes("motorcycle");
                      const isBackground = currentPageUrl.includes("background");
                      let maxCharacters = 7;
                      let optionsArray = optionsArrayDefault;
                      if (isMotorcycle) {
                        optionsArray = optionsArrayMotorcycle;
                        maxCharacters = 6;
                      }
                      if (isBackground) {
                        optionsArray = optionsArrayVehicle;
                        maxCharacters = 6;
                      }
          
                      
            
                      // Create options and images
                      const optionsHtml = optionsArray.map(optionValue => {
                          const displayValue = optionValue.replace(/-/g, ' ');
                          return `<option value="${optionValue}">${displayValue}</option>`;
                      }).join('');
          
                      const imagesHtml = optionsArray.map(optionValue => {
                          const imageUrl = `https://cdn.shopify.com/s/files/1/0642/8599/9281/files/${optionValue}.jpg`;
                          return `<img class="tags-img" src="${imageUrl}" alt="${optionValue}" data-value="${optionValue}" style="cursor: pointer; margin: 2.5%; width: 20%; transition: opacity 0.3s;">`;
                      }).join('');
          
                      // Insert options and images into DOM
                      selectElement.innerHTML = optionsHtml;
                      imageListElement.innerHTML = imagesHtml;
          
                      // Update main product image and select element on image click
                      imageListElement.addEventListener('click', function(event) {
                          const target = event.target;
                          if (target.tagName.toLowerCase() === 'img') {
                              const selectedOptionValue = target.getAttribute('data-value');
                              const imageUrl = `https://cdn.shopify.com/s/files/1/0642/8599/9281/files/${selectedOptionValue}.jpg`;
                              mainProductImageElement.src = imageUrl;
                              mainProductImageElement.srcset = "";
          
                              // Update the select element
                              selectElement.value = selectedOptionValue;
                          }
                      });
          
                      // Update main product image on select change
                      selectElement.addEventListener('change', function () {
                          const selectedOptionValue = selectElement.value;
                          const imageUrl = `https://cdn.shopify.com/s/files/1/0642/8599/9281/files/${selectedOptionValue}.jpg`;
                          mainProductImageElement.src = imageUrl;
                          mainProductImageElement.srcset = "";
                      });
          
                      // Trigger change event to set the initial image
                      selectElement.dispatchEvent(new Event('change'));
          
                      // Field input validation
                      // Disable add to cart button
                      // There are 3 input fields with name properties such as name="properties[Custom Plate 1]", name="properties[Custom Plate 2]", name="properties[Custom Plate 3]"
                      // Create a state object with { customPlate1:false, customPlate2:false, customPlate3:false }
                      // Add Listener on all 3 fields with change handler
                      // Add regex validation logic that limits input to alphanumeric characters and spaces
                      // Add check for length between 1 to 7 characters
                      // If field validation passes, set state property to true ie, customPlate1:true
                      // Add a condition check that all state properties are true, and then enable add to cart button
                      // State object to track validation
            const state = {
              customPlate1: false,
              customPlate2: false,
              customPlate3: false
            };
          
            // Input fields and Add to Cart button
            const inputFields = [
              document.getElementById('customPlate1'),
              document.getElementById('customPlate2'),
              document.getElementById('customPlate3'),
              
            ];
            console.log("inputFields",inputFields);
            const addToCartButton = document.querySelector('.product-form__submit');
            addToCartButton.disabled = true;
          
            // Validation function
            function validateInput(value) {
              const regexPattern = new RegExp(`^[A-Z0-9 &]{2,${maxCharacters}}$`);
              const isValid = regexPattern.test(value);
              return isValid;
            }
          
            // Event handler for input change
            function handleInputChange(event) {
              const input = event.target;
              const valueClean = input.value.toUpperCase().replace("O","0").substring(0,maxCharacters);
              if (input.value != valueClean) {
                input.value = valueClean;
              }
              const isValid = validateInput(valueClean);
              const fieldId = input.getAttribute('id');
              
              state[fieldId] = isValid;
          
              // Check if all state properties are true
              const allValid = Object.values(state).every(value => value === true);
          
              console.log("state",state);
              console.log("isValid",isValid);
              
              // Enable or disable the add to cart button
              addToCartButton.disabled = !allValid;
            }
          
            // Add event listeners to all input fields
            inputFields.forEach(input => {
              input.addEventListener('input', handleInputChange);
            });
            }
  

        });








// REQUIRED FIELDS FOR RENEWALS
document.addEventListener('DOMContentLoaded', function () {
    const currentPageUrl = window.location.href;

    function runValidation() {
      
        // Field input validation
        // Disable add to cart button
        // Create a state object with { controlNumber: null }
        // Add Listener on all fields with change handler
        // Add regex validation logic that limits input to alphanumeric characters and spaces
        // Add check for length between 1 to 7 characters
        // If field validation passes, set state property to true ie, customPlate1:true
        // Add a condition check that all state properties are true, and then enable add to cart button
        // State object to track validation
        const state = {
          controlNumber: null,
        };
      
        // Input fields and Add to Cart button
        const inputFields = [
          document.getElementById('controlNumber'),
          
        ];

        const addToCartButton = document.getElementById('pp-button-div');
              console.log("addToCartButton",addToCartButton);

        const defaultButtonStyle = "pointer-events: none; padding-right: 0px; padding-left: 0px; opacity: 0.5 !important; padding-top: 13px !important; padding-bottom: 10px !important;";
        addToCartButton.style = defaultButtonStyle;

      
        // Validation function
        function validateInput(value) {
          const regexPattern = new RegExp(`^C[A-Za-z0-9]{7}$`);
          const isValid = regexPattern.test(value);
          return isValid;
        }
      
        // Event handler for input change
        function handleInputChange(event) {
          const input = event.target;
          const valueClean = input.value;
          if (input.value != valueClean) {
            input.value = valueClean;
          }
          const isValid = validateInput(valueClean);
          const fieldId = input.getAttribute('id');
          
          state[fieldId] = isValid;
      
          // Check if all state properties are true
          const allValid = Object.values(state).every(value => value === true);
      
          console.log("state",state);
          console.log("isValid",isValid);
          
          // Enable or disable the add to cart button
            if (allValid) {
                addToCartButton.style = "padding-right: 0px; padding-left: 0px; opacity: 1; padding-top: 13px !important; padding-bottom: 10px !important;";
            } else {
                addToCartButton.style = defaultButtonStyle;
            }
          }
        
          // Add event listeners to all input fields
          inputFields.forEach(input => {
            input.addEventListener('input', handleInputChange);
          });
    }

    if (currentPageUrl.includes("renewal")) {

      setTimeout(runValidation, 4000);
      
    }
});